module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', [_h('div', {
    staticClass: "title"
  }, [_vm._s(_vm.item.title)]), (_vm.item.contents) ? _h('p', {
    staticClass: "small"
  }, [_vm._s(_vm.item.author) + " " + _vm._s(_vm._f("time")(_vm.item.timeCreate))]) : _vm._e(), _vm._l((_vm.item.contents), function(i) {
    return _h('div', {
      attrs: {
        "style": "margin:0 0;padding:0 0"
      }
    }, [(i.type === 8) ? _h('div', [_h('img', {
      staticClass: "media-object",
      attrs: {
        "src": 'https://qiniu443.alltennis.cn/' + i.data,
        "style": "width:100%"
      },
      on: {
        "click": function($event) {
          _vm.jumpto(i.url)
        }
      }
    })]) : _vm._e(), (i.type === 1) ? _h('div', {
      domProps: {
        "innerHTML": _vm._s(i.data)
      }
    }) : _vm._e()])
  }), (_vm.item.contents) ? _h('p', {
    attrs: {
      "id": "qr"
    }
  }, [_vm._m(0)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _h('img', {
    attrs: {
      "src": require("../qrcode.png")
    }
  })
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-294f6aaf", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-294f6aaf!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/item.vue
// module id = 25
// module chunks = 0